"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingPortalUrl = exports.acceptSubscriptionOffer = exports.checkSubscriptionOffer = exports.syncIosReceipt = exports.subscribeWeb = exports.subscribeAndroid = exports.subscribeIos = void 0;
function subscribeIos(client, opts) {
    return client.post('subscribe_ios', { code: opts.code });
}
exports.subscribeIos = subscribeIos;
function subscribeAndroid(client, opts) {
    return client.post('subscribe_android', {
        code: opts.code,
        purchase_token: opts.purchaseToken
    });
}
exports.subscribeAndroid = subscribeAndroid;
function subscribeWeb(client, opts) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post('subscribe_web', opts.stripeSubscription);
    });
}
exports.subscribeWeb = subscribeWeb;
function syncIosReceipt(client, opts) {
    return client.post('sync_ios_receipt', {
        receipt_data: opts.receiptData
    });
}
exports.syncIosReceipt = syncIosReceipt;
function checkSubscriptionOffer(client) {
    return client.post('check_subscription_offer', {});
}
exports.checkSubscriptionOffer = checkSubscriptionOffer;
function acceptSubscriptionOffer(client) {
    return client.post('accept_subscription_offer', {});
}
exports.acceptSubscriptionOffer = acceptSubscriptionOffer;
function getBillingPortalUrl(client) {
    return client.post('get_billing_portal_url', {});
}
exports.getBillingPortalUrl = getBillingPortalUrl;
